import { render, staticRenderFns } from "./NominationFiles.vue?vue&type=template&id=3ab67ffa&scoped=true&"
import script from "./NominationFiles.vue?vue&type=script&lang=js&"
export * from "./NominationFiles.vue?vue&type=script&lang=js&"
import style0 from "./NominationFiles.vue?vue&type=style&index=0&id=3ab67ffa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab67ffa",
  null
  
)

export default component.exports